import { render, staticRenderFns } from "./AppUpload.vue?vue&type=template&id=3c050880&"
import script from "./AppUpload.vue?vue&type=script&lang=js&"
export * from "./AppUpload.vue?vue&type=script&lang=js&"
import style0 from "./AppUpload.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports